import Component from 'component';
import VanillaModal from 'vanilla-modal';

class EmailDisclaimerModal extends Component{
  constructor(el, config){
    super(el, config);
    this.modal = new VanillaModal();
  }

  setupDefaults() {
    this.dom = {
      modal: '#wh-email-disclaimer-modal',
      $modalContainer: $('.modal'),
      $acceptBtn: $('.wh-email-disclaimer-modal__accept'),
      $cancelBtn: $('.wh-email-disclaimer-modal__cancel')
    };
  }

  addListeners() {
    this.$el.on('click', 'a[href^="mailto:"]', ::this.onLinkClick);
    this.dom.$acceptBtn.on('click', ::this.onMailTo);
    this.dom.$cancelBtn.on('click', ::this.onCancel);
  }

  onLinkClick(e) {
    const $target = $(e.currentTarget);
    // Do nothing if it's the the accept button on the modal
    if ($target.hasClass('wh-email-disclaimer-modal__accept')) {
      return;
    }

    const email = $target.attr('href').toLowerCase();
    if (email.endsWith('wilmerhale.com')) {
      e.preventDefault();
      this.dom.$acceptBtn.attr('href', email);

      if (!email) return;

      this.modal.open(this.dom.modal);
    }
  }

  onMailTo() {
    this.modal.close();
  }

  onCancel(e) {
    e.preventDefault();
    this.modal.close();
  }
}


export default EmailDisclaimerModal;



// WEBPACK FOOTER //
// ./src/js/components/EmailDisclaimerModal.js